import * as ts from 'type-schema';
import {user} from '../../lib/user';
import {result} from '../../lib/result';

/** 這個檔案不能跟 ../../lib/user 合併。因為這裡是只針對前端的程式碼 */

export function load(): user | null {
    const data = localStorage.getItem('user');
    if (data) {
        const res = ts.transform(user.schema, JSON.parse(data));
        if (result.error(res)) {
            const [error, _] = res;
            throw new Error(error);
        } else {
            const [_, user] = res;
            return user;
        }
    } else {
        return null;
    }
}

export function save(user: user) {
    const data = {
        ...user,
        exp: user.exp.getTime() / 1000,
    };
    localStorage.setItem('user', JSON.stringify(data));
}

export function clear() {
    localStorage.removeItem('user');
}
